// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Container, Grid, List, Segment, Header, Icon } from 'semantic-ui-react'
import MailChimp from './MailChimp'

export default class Footer extends Component {
  render () {
    return (
      <div style={{ maxWidth: '100%', backgroundColor: '#fafafa' }}>
        <Container >
          <Segment vertical>
            <Grid
              className='footerGrid'
              stackable
              centered
              doubling
              relaxed
              stretched
              verticalAlign='top'>
              <Grid.Row>
                <Grid.Column width={4}>
                  <Header as='h4' content='Never miss an update' />
                  <MailChimp />
                </Grid.Column>

                <Grid.Column width={4}>
                  <List link>
                    <List.Item href='/blog'>
                      <List.Content>
                        <span style={{ color: '#000' }}>Blog</span>
                      </List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content href='/pricing'>
                        <span style={{ color: '#000' }}>Pricing</span>
                      </List.Content>
                    </List.Item>
                    <List.Item href='/contact'>
                      <List.Content>
                        <span style={{ color: '#000' }}>Contact</span>
                      </List.Content>
                    </List.Item>
                    <List.Item
                      href='https://murkstom.kampsite.co/'
                      rel='noopener noreferrer'
                      target='_blank'>
                      <span style={{ color: '#000' }}>Road map</span>
                    </List.Item>
                    <List.Item
                      href='https://murkstom.joliefaq.io/'
                      rel='noopener noreferrer'
                      target='_blank'>
                      <span style={{ color: '#000' }}>Help Center</span>
                    </List.Item>
                  </List>
                </Grid.Column>

                <Grid.Column width={4}>
                  <Header as='h4' content='Social' />
                  <List link>
                    <List.Item
                      href='https://twitter.com/murkstom'
                      rel='noopener noreferrer'
                      target='_blank'>
                      <List.Icon color='black' name='twitter' />
                      <List.Content>
                        <span style={{ color: '#000' }}>Twitter</span>
                      </List.Content>
                    </List.Item>
                    <List.Item
                      href='https://instagram.com/murkstom'
                      rel='noopener noreferrer'
                      target='_blank'>
                      <List.Icon color='black' name='instagram' />
                      <List.Content>
                        <span style={{ color: '#000' }}>Instagram</span>
                      </List.Content>
                    </List.Item>
                    <List.Item
                      rel='noopener noreferrer'
                      target='_blank'
                      href='https://www.linkedin.com/company/murkstomsarl/'>
                      <List.Icon color='black' name='linkedin' />
                      <List.Content>
                        <span style={{ color: '#000' }}>LinkedIn</span>
                      </List.Content>
                    </List.Item>
                  </List>
                </Grid.Column>

                <Grid.Column width={4}>
                  <Header as='h4' content='Legal' />
                  <List link>
                    <List.Item href='/about'>
                      <span style={{ color: '#000' }}>About</span>
                    </List.Item>
                    <List.Item href='/privacy'>
                      <span style={{ color: '#000' }}>Privacy Policy</span>
                    </List.Item>
                    <List.Item href='/terms'>
                      <span style={{ color: '#000' }}>Terms of Service</span>
                    </List.Item>
                  </List>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </Container>
        <center style={{ backgroundColor: '#000', color: '#eee', padding: '2vh' }}>
          <h4>
          Copyright © 2018 - 2020 Murkstom SARL. All Rights Reserved.
          </h4>
        </center>
      </div>
    )
  }
}
